export var uk = {
  meta: {
    title: "UgrzejMnie — Паливо, опалення, кондиціонування і фотовольтаїка в Польщі",
    description: "UgrzejMnie — замовте паливо (пропан, пелети, еко-горох, газ), сервіс котла та теплового насоса, кондиціонування або фотовольтаїку. Місцеві техніки відповідають, ви обираєте найкращу пропозицію.",
    ogTitle: "UgrzejMnie — Паливо, сервіс, AC і PV",
    ogDescription: "Замовте паливо, сервіс опалення, кондиціонування або фотовольтаїку за кілька хвилин. Місцеві фахівці відповідають — ви обираєте пропозицію.",
  },
  nav: {
    skip: "Перейти до вмісту",
    homeAria: "UgrzejMnie — головна сторінка",
    aria: "Головна навігація",
    home: "Головна",
    how: "Як це працює",
    app: "Додаток",
    offer: "Що ви замовляєте",
    service: "Сервіс",
    payments: "Оплата",
    trust: "Безпека",
    provider: "Для постачальників",
    fuelProviders: "Для Складів Палива",
    technicians: "Для Сервісантів",
    more: "Більше",
    download: "Завантажити додаток",
    game: "Гра",
    menu: "Меню",
  },
  lang: {
    label: "Вибрати мову",
  },
  trustBar: {
    label: "Гнучкі розрахунки",
    text: "Онлайн-оплата через Stripe, відстрочена Klarna (30 днів) або готівкою при доставці — залежно від пропозиції постачальника.",
  },
  hero: {
    headline: "Паливо і сервіс котельні — коли потрібно.",
    lead: "Замовте пропан, пелети, газ, еко-горох, сервіс опалення, кондиціонування або фотовольтаїку за кілька хвилин. Місцеві техніки відповідають — ви обираєте пропозицію.",
    downloadAndroid: "Завантажити на Android",
    downloadIos: "Завантажити на iPhone (незабаром)",
    securityNote: "Замовляйте безпечно у додатку — підтвердження замовлення вимагає вашої чіткої дії.",
    forProviders: "Для постачальників",
    playGame: "Грати в Ugrzej Osiedle",
  },
  how: {
    heading: "Як це працює",
    sub: "Три кроки — від заявки до доставки або сервісу у вас вдома.",
    step1: {
      title: "Зробіть замовлення",
      desc: "Опишіть потребу — паливо, сервіс опалення, кондиціонування або фотовольтаїку. Вкажіть місцезнаходження і дату.",
    },
    step2: {
      title: "Пропозиції техніків",
      desc: "Місцеві постачальники і техніки відповідають у додатку. Порівнюйте ціни і терміни.",
    },
    step3: {
      title: "Доставка / сервіс",
      desc: "Оберіть пропозицію — паливо їде до вас, технік приїжджає у домовлений час.",
    },
    cluster: {
      kicker: "Паливо з сусідами",
      title: "Спільна доставка",
      desc: "Замовляєте пелети, вугілля чи газ? Відкрийте спільну доставку в додатку і надішліть посилання сусідам. Об'єднуйте обсяги на один маршрут — часто дешевше, ніж окремі поїздки.",
      cta: "Відкрити в додатку",
    },
  },
  app: {
    heading: "Додаток у дії",
    sub: "Клієнт, постачальник і робочий стіл — так виглядає UgrzejMnie зсередини.",
    slide1: "Швидке замовлення",
    slide2: "Каталог послуг",
    slide3: "Пропозиції та ціни",
    slide4: "Панель постачальника",
    slide5: "Ваші спеціалізації",
    slide6: "Оцінка замовлення",
    slide7: "Десктоп замовлень",
    slide8: "Швидкий кошторис",
    prev: "Попередній екран",
    next: "Наступний екран",
    dots: "Вибір екрана",
    dot: "Екран",
  },
  offer: {
    heading: "Що ви замовляєте",
    sub: "Один додаток для палива, опалення, кондиціонування і фотовольтаїки — фахівець, коли потрібно.",
    propan: {
      title: "Пропан",
      desc: "Заправка резервуара — доставка на вашу адресу без дзвінків дистрибуторам.",
    },
    pellet: {
      title: "Пелети і еко-горох",
      desc: "Сезонні замовлення твердого палива — порівняйте пропозиції місцевих постачальників.",
    },
    heatpump: {
      title: "Тепловий насос",
      desc: "Огляд, сервіс і ремонт — техніки з досвідом роботи з вашою системою опалення.",
    },
    solidBoiler: {
      title: "Котел на твердому паливі",
      desc: "Чищення, регулювання горіння, заміна деталей — сервіс на місці.",
    },
    gas: {
      title: "Газ і LPG",
      desc: "Доставка і заправка газових резервуарів, сервіс газових котелень та установок LPG.",
    },
    electric: {
      title: "Електроопалення",
      desc: "Огляди, ремонти і заміна компонентів систем електроопалення будинку.",
    },
    ac: {
      title: "Кондиціонування",
      desc: "Сервіс, чищення і монтаж кондиціонерів — місцеві техніки з дозволом F-Gas.",
    },
    pv: {
      title: "Фотовольтаїка",
      desc: "Сервіс установок PV, а також монтаж або розширення — пропозиції місцевих інсталяторів.",
    },
  },
  reminders: {
    heading: "Не пропустіть технічне обслуговування",
    sub: "Збережіть свою опалювальну систему, і UgrzejMnie нагадає вам про дату сервісу до початку сезону.",
    step1: {
      title: "Додайте котельню",
      desc: "Збережіть адресу, тип опалення, модель котла або теплового насоса та параметри системи в одному місці.",
    },
    step2: {
      title: "Встановіть дату сервісу",
      desc: "Оберіть дату наступного огляду. Система сама підрахує, скільки часу залишилося до візиту техніка.",
    },
    step3: {
      title: "Отримайте нагадування",
      desc: "Перед датою ви отримаєте сповіщення і зможете легко замовити сервіс у перевіреного місцевого фахівця.",
    },
  },
  payments: {
    heading: "Зручні і безпечні платежі за паливо і сервіс",
    sub: "На ugrzejmnie.pl ми з'єднуємо вас безпосередньо з місцевими постачальниками опалювального палива і техніками. Постачальники встановлюють прийнятні способи оплати для своїх пропозицій, тому ви можете обрати найбільш підходяще рішення.",
    klarna: {
      title: "Купіть зараз, заплатіть пізніше з Klarna",
      desc: "Вибрані постачальники пропонують гнучку відстрочену оплату Klarna. Замовте пелети, еко-горох, дрова або газ і побачите умови погашення (включно з можливими розстрочками) в Klarna Checkout перед підтвердженням.",
      note: "Доступно у постачальників, які пропонують платежі Klarna",
    },
    stripe: {
      title: "Швидкі та безпечні платежі Stripe",
      desc: "Платіть миттєво карткою (Visa, Mastercard) або через інші способи оплати, доступні в Stripe Checkout. Stripe гарантує високий рівень безпеки (PCI-DSS) і підтвердження транзакції.",
      note: "Доступно у постачальників, які підтримують онлайн-оплату",
    },
    cash: {
      title: "Готівкова оплата",
      desc: "Віддаєте перевагу традиційному способу? Багато місцевих постачальників дозволяють розрахуватися готівкою при доставці або виконанні послуги — за базовою ціною пропозиції, без плати платформи (0 PLN).",
      note: "Деталі оплати дивіться на картці конкретної пропозиції",
    },
    promo: {
      title: "Замовте паливо на зиму без негайного навантаження на бюджет",
      desc: "Шукайте на ugrzejmnie.pl постачальників, які пропонують платежі Klarna — отримайте паливо відповідно до угоди, а розрахунок з Klarna проведіть за її умовами, показаними в Checkout.",
      days: "30",
      daysUnit: "днів",
    },
  },
  trust: {
    heading: "Довіра і безпека",
    sub: "Ваші дані і платежі захищені на кожному етапі — від замовлення до розрахунку з постачальником.",
    encryption: {
      title: "Зашифровані персональні дані",
      desc: "Конфіденційні дані, такі як ідентифікаційний номер при доставці палива, шифруються і передаються лише обраному постачальнику.",
    },
    certified: {
      title: "Сертифіковані платежі",
      desc: "Онлайн-платежі обробляються Stripe з найвищим стандартом безпеки PCI-DSS Level 1. Дані вашої картки ніколи не зберігаються на наших серверах.",
    },
    marketplace: {
      title: "Маркетплейс місцевих постачальників",
      desc: "UgrzejMnie з'єднує вас з перевіреними техніками і постачальниками у вашому регіоні. Договір і виконання залишаються між вами і обраним фахівцем.",
    },
    notifications: {
      title: "Сповіщення про статус замовлення",
      desc: "Ви отримуєте сповіщення про нові пропозиції, зміни статусу і наближення сервісу, щоб нічого не пропустити.",
    },
  },
  provider: {
    heading: "Станьте постачальником UgrzejMnie",
    sub: "Знайдіть клієнтів, яким потрібне паливо, сервіс опалення, кондиціонування або фотовольтаїка у вашому регіоні. Керуйте пропозиціями, платежами і замовленнями з телефону та комп'ютера — в одній екосистемі.",
    benefitMixedRoute: {
      title: "Змішані маршрути A+B та рейс дня",
      desc: "Поєднуйте замовлення з платформи з власними клієнтами на одній вантажівці. Додавайте власні доставки за символічну плату 0,5% (мін. 3 PLN). Система автоматично оптимізує порядок зупинок від вашого складу та контролює вагу.",
    },
    benefitDriverManifest: {
      title: "Водій без додатків, електронна ТТН та офлайн",
      desc: "Жодного встановлення чи входу. Вранці водій сканує 1 QR-код: навігація Google Maps, збір готівки, цифровий підпис клієнта та додавання замовлень прямо в дорозі навіть без зв'язку.",
    },
    benefit1: {
      title: "Гнучкі платежі і прозорі комісії",
      desc: "Ви вирішуєте, чи приймати готівку, онлайн-оплату (Stripe, картка) чи Klarna. Комісії платформи видно при кожній пропозиції, а ви отримуєте кошти безпосередньо від клієнта.",
    },
    benefit2: {
      title: "Замовлення у WhatsApp",
      desc: "Вам не потрібно постійно стежити за додатком. Увімкніть сповіщення WhatsApp і нові замовлення у вашому регіоні надходитимуть прямо на ваш телефон. Надішліть пропозицію одним кліком через спеціальне, безпечне посилання — без входу в панель.",
    },
    benefit3: {
      title: "Настільний додаток",
      desc: "Працюєте за столом? Завантажте версію для Windows, macOS або Linux і керуйте замовленнями з комп'ютера. Повне управління обліковим записом залишається в мобільному додатку, тому конфіденційні налаштування в безпеці.",
    },
    benefit4: {
      title: "Встановіть зону обслуговування",
      desc: "Ви вирішуєте, як далеко їздити. Встановіть радіус від 10 до 200 км — зміни синхронізуються автоматично між мобільним додатком і настільним комп'ютером.",
    },
    benefit5: {
      title: "Підписка і розрахунки в одному місці",
      desc: "Керуйте підпискою, способами виплат і історією комісій з вкладки Профіль. Все прозоро і доступно одразу після входу.",
    },
    benefit6: {
      title: "Спільні доставки — повніший маршрут",
      desc: "Клієнти об'єднують доставки палива в одну спільну заявку. Ви отримуєте кілька точок на спільному маршруті і оцінюєте їх разом замість окремих поїздок.",
    },
    promo: {
      kicker: "Промоція для техніків",
      title: "Перше сервісне замовлення безкоштовно",
      desc: "Немає замовлення — немає плати. Ви бачите заявки і можете давати кошторис без підписки. З другого виконаного замовлення (теплові насоси, котли, опалення, кондиціонери, PV) діє плата за категорію. Доставка палива без змін.",
    },
    pricing: {
      kicker: "Прайс для постачальників",
      title: "Приклад ставок платформи",
      disclaimer:
        "Це приклад прайсу. Ставки можуть встановлюватися індивідуально після контакту.",
      commissionsTitle: "Комісії з доставки палива",
      subsTitle: "Сервісні підписки (30 днів)",
      loading: "Завантаження прайсу…",
      error: "Не вдалося завантажити прайс.",
      cta: "Запитати індивідуальну пропозицію",
      cat: {
        heat_pumps: "Сервіс теплових насосів",
        boilers: "Сервіс котлів і печей",
        installations: "Сервіс опалювальних систем",
        ac: "Кондиціонування (сервіс і монтаж)",
        pv: "Фотовольтаїка та накопичувачі",
      },
    },
    mobileApp: "Мобільний додаток",
    apiBadge: "Для систем ERP / TMS / WMS",
    apiTitle: "Проста інтеграція API & Webhooks",
    apiDesc: "Використовуєте власну систему ERP, TMS або складську програму (напр. Subiekt, Optima, SAP)? Отримуйте запити, надсилайте пропозиції та передавайте цифрові підписи доставки на 100% автоматично через наше безпечне REST API та вебхуки.",
    apiTag1: "Автоматичні замовлення",
    apiTag2: "Вебхуки в реальному часі",
    apiTag3: "API-ключі & HMAC",
    apiCta: "Відкрити Портал Інтегратора (API Docs)",
    gatewayFuelTitle: "Склади Палива & Дистриб'ютори Газу",
    gatewayFuelDesc: "Змішаний маршрут A+B (0,5%), 1 QR-код для водія, цифрова e-WZ та прозорий тариф.",
    gatewayTechTitle: "Монтажники & Сервісанти HVAC",
    gatewayTechDesc: "Теплові насоси (F-Гази), котли, кондиціонери, безкоштовний тест (1-ше замовлення без комісії).",
    desktopTitle: "Настільний додаток",
    desktopNote: "Повне управління обліковим записом, спеціалізаціями і підпискою залишається в мобільному додатку — щоб конфіденційні налаштування і дозволи були під контролем на вашому телефоні. Настільний комп'ютер містить лише необхідний мінімум для комфортної роботи за столом: сповіщення про замовлення і швидкі кошториси.",
    formTitle: "Почніть продавати з нами",
    formSubtitle: "Заповніть коротку форму, і ми зв'яжемося з вами",
    fieldName: "Ім'я та прізвище / Назва компанії",
    fieldNamePlaceholder: "напр. Іван Петренко / Газ-Буд ТОВ",
    fieldEmail: "E-mail",
    fieldEmailPlaceholder: "ваш@email.ua",
    fieldPhone: "Номер телефону",
    fieldPhonePlaceholder: "+48 600 700 800",
    fieldCity: "Місто і зона обслуговування",
    fieldCityPlaceholder: "напр. Краків і околиці до 30 км",
    fieldServices: "Пропоновані послуги / продукти",
    servicePropan: "Пропан",
    servicePellet: "Пелети / Еко-горох",
    serviceBoiler: "Сервіс котлів / насосів",
    serviceAc: "Кондиціонування",
    servicePv: "Фотовольтаїка",
    fieldNotes: "Додаткова інформація (необов'язково)",
    fieldNotesPlaceholder: "Розкажіть кілька слів про свою компанію...",
    consent: "Я даю згоду на обробку моїх персональних даних відповідно до",
    consentPrivacy: "Політики конфіденційності",
    consentPurpose: "з метою обробки цього запиту і комерційного контакту.",
    captchaLabel: "Антиспам-верифікація",
    captchaLoading: "Завантаження питання...",
    captchaRefresh: "Оновити питання",
    captchaPlaceholder: "Введіть відповідь",
    submit: "Надіслати заявку",
    sending: "Надсилання...",
    instructWin: "<strong>Інструкція (Windows):</strong> Завантажте і запустіть інсталятор <code>.exe</code>. Програма встановиться автоматично і додасть ярлик на робочий стіл.",
    instructMac: "<strong>Інструкція (macOS):</strong> Завантажте файл <code>.dmg</code> (оберіть Apple Silicon для нових Mac з чіпами M1/M2/M3/M4 або Intel для старіших моделей). Відкрийте його і перетягніть програму до папки Програми.",
    instructLinux: "<strong>Інструкція (Linux):</strong> Ми рекомендуємо пакет <code>.deb</code> (іконка і системне меню). Якщо ви використовуєте версію <code>AppImage</code>, після завантаження позначте файл як виконуваний (<code>chmod +x</code>) і у файловому менеджері оберіть «Дозволити запуск».",
    loadingVersions: "Завантаження версій…",
    refreshVersions: "Оновити список версій",
    errorNoAssets: "У найновішому випуску не знайдено файлів для встановлення.",
    errorLoad: "Не вдалося отримати список версій. Будь ласка, спробуйте пізніше.",
    currentVersion: "Поточна версія:",
    draft: "(чернетка)",
    seeDownloads: "Переглянути розділ завантажень",
    warningWin: "Додаток наразі проходить перевірку в Microsoft Store. Якщо Windows відобразить попередження перед запуском, натисніть <em>«Детальніше»</em>, а потім <em>«Все одно запустити»</em>. Запевняємо, що програма є повністю безпечною.",
  },
  b2bFuel: {
    trustBar: "Змішаний маршрут A+B (0,5% мін. 3 PLN) · 1 QR-маніфест для водія · Цифрова e-WZ з підписом та акцизним ID.",
    badge: "Логістична екосистема для складів палива та дистриб'юторів",
    headline: "Більше замовлень на маршруті та жодних паперових накладних.",
    lead: "Об'єднуйте власних клієнтів із замовленнями з мережі UgrzejMnie на одній вантажівці. Давайте водієві 1 щоденний QR-код, оформлюйте цифрові накладні e-WZ з акцизними заявами та працюйте 100% офлайн.",
    btnRegister: "Зареєструвати склад",
    btnPricing: "Переглянути тарифи",
    btnPdf: "Завантажити PDF (2 стор. A4)",
    featuresHeadline: "Як UgrzejMnie оптимізує ваш склад палива?",
    featuresLead: "Розроблено спеціально для польських складів палива, водіїв автоцистерн та податкових перевірок.",
    cardMixedRouteTitle: "Змішаний маршрут A+B",
    cardMixedRouteDesc: "Маєте постійних клієнтів? Вносьте їхні замовлення (Stream B) за символічну плату 0,5% (мін. 3 PLN, макс. 5 PLN) та добирайте мережеві замовлення (Stream A) дорогою. Жодних порожніх рейсів.",
    cardMixedRouteBadge: "Спільна вага & TSP",
    cardQrTitle: "Рейс Дня та QR-маніфест",
    cardQrDesc: "Водій вранці сканує 1 QR-код з кабіни. Порядок зупинок автоматично оптимізується від вашого складу з навігацією Google Maps в 1 клік.",
    cardQrBadge: "Без встановлення додатків",
    cardEwzTitle: "Цифрова e-WZ та Акцизний Щит",
    cardEwzDesc: "Обов'язковий PESEL/номер паспорта, заява про звільнення від акцизу, цифровий підпис клієнта на смартфоні, GPS-мітки та експорт у CSV для податкової.",
    cardEwzBadge: "Податковий захист",
    cardOfflineTitle: "100% Офлайн та замовлення з дороги",
    cardOfflineDesc: "Немає зв'язку LTE у клієнта? Маніфест, підтвердження та підписи працюють офлайн. Водій також може додати клієнта прямо на місці.",
    cardOfflineBadge: "Outbox Sync",
    cardAdjustTitle: "Авто-розрахунок літражу",
    cardAdjustDesc: "Для доставок цистерною: якщо в резервуар увійшло менше замовленого, система миттєво повертає різницю на картку (Stripe Connect).",
    cardAdjustBadge: "Без суперечок",
    cardApiTitle: "Відкритий API Інтегратора",
    cardApiDesc: "Підключіть UgrzejMnie безпосередньо до ERP/TMS вашого складу (Subiekt, Symfonia, SAP). Замовлення та пропозиції надходять через безпечні вебхуки.",
    cardApiBadge: "REST + Webhooks",
    puescBadge: "Доступно — Інтеграція з PUESC",
    puescHeadline: "SENT та e-DD прямо з маршруту — автоматично до Мінфіну",
    puescLead: "Модуль PUESC працює в додатку постачальника та на комп’ютері. Декларації SENT (транспортні) та e-DD (акцизні) виникають із виконання маршруту і підписуються кваліфікованим підписом — без ручного перенесення даних до е-Податкової.",
    puescSoon: "Доступно",
    puescSentTitle: "SENT — Транспортні Декларації",
    puescSentDesc: "Автоматичні повідомлення про транспортування акцизних товарів до Системи Електронного Нагляду за Транспортом. Дані маршруту, транспортного засобу та водія беруться безпосередньо з Денного Курсу — без дублювання записів у е-Податковій.",
    puescEddTitle: "e-DD — Електронні Документи Доставки",
    puescEddDesc: "Електронні документи доставки для акцизного палива, підписані кваліфікованим сертифікатом XAdES. Генеруються автоматично з e-WZ після підтвердження клієнтом — з номером PESEL, GPS-міткою та акцизною декларацією.",
    puescCtaTitle: "Увімкніть SENT та e-DD на своєму складі",
    puescCtaDesc: "Модуль PUESC входить до планів Pro та Enterprise. Оберіть пакет для автопарку або напишіть — впровадимо його на ваших маршрутах.",
    puescCtaBtn: "Переглянути пакети",
    lpgSentBadge: "SENT для станцій LPG / автогаз",
    lpgSentHeadline: "Один маршрут — три шляхи закриття SENT зі станцією",
    lpgSentLead: "Поставки LPG автогаз на АЗС потребують SENT-100 і SENT-103 з показаннями колонок. UgrzejMnie розрізняє власні станції (той самий NIP) і чужі та підтримує RecipientKey (KR-…) — без входу станції в ваш обліковий запис PUESC.",
    lpgPathOwnKicker: "1 · Власний NIP",
    lpgPathOwnTitle: "Власна станція / та сама компанія",
    lpgPathOwnDesc: "Після розвантаження водій фіксує показання колонок. Система закриває SENT-103 у PUESC від імені постачальника (STANDARD) — без ключа KR.",
    lpgPathKrKicker: "2 · Чужий NIP + KR",
    lpgPathKrTitle: "Франшиза / партнерська станція з RecipientKey",
    lpgPathKrDesc: "Станція один раз вказує KR-… (email-портал або каталог). Після поставки ви закриваєте SENT-103 від її імені: офіційний номер SENT + RecipientKey + показання.",
    lpgPathExtKicker: "3 · Чужий NIP без KR",
    lpgPathExtTitle: "Станція закриває у власному PUESC",
    lpgPathExtDesc: "Лист із референсом, потім офіційний номер SENT і показання колонок. Станція закриває SENT-103 у себе; оператор підтверджує в desktop (CONFIRMED_EXTERNALLY).",
    lpgSentBullet1: "Два листи на станцію: після реєстрації (референс) і після присвоєння офіційного номера SENT у PUESC.",
    lpgSentBullet2: "Портал станції (magic link) для одноразового введення RecipientKey — без акаунта у вашому додатку.",
    lpgSentBullet3: "Показання лічильників з маршруту; можлива корекція до зовнішнього підтвердження.",
    lpgSentDocBtn: "Інформатор SENT станції LPG (HTML / друк PDF)",
    lpgSentContactBtn: "Обговорити впровадження на станціях",
    lpgSentLegal: "Як і в усьому модулі PUESC: відповідальність за подання та права в SISC залишається за постачальником. Інструмент не замінює обліковий запис PUESC станції чи податкові рішення.",
    pricingKicker: "Тарифи для постачальників палива",
    pricingHeadline: "Комісія лише за нові замовлення + Абонемент для автопарку",
    pricingLead: "0% комісії за власних постійних клієнтів (Stream B). Ви сплачуєте комісію за успіх лише тоді, коли ми приводимо нового покупця з ринку.",
    streamATitle: "Замовлення з платформи (Stream A)",
    streamADesc: "Для замовлень, отриманих з додатків UgrzejMnie від власників будинків та підприємств вашого регіону.",
    streamARate: "0,5% – 1,0%",
    streamANote: "Комісія успіху нараховується тільки за виконані замовлення",
    streamBTitle: "Власні замовлення складу (Stream B)",
    streamBDesc: "Для постійних клієнтів вашого складу, дзвінків або імпорту з Excel. 0% комісії від продажу.",
    streamBRate: "0 PLN (0% комісії)",
    streamBNote: "0 PLN комісії від продажу вашого палива та власних клієнтів",
    monthlyInvoiceTitle: "Один зведений рахунок B2B раз на місяць",
    monthlyInvoiceDesc: "Комісії за замовлення з ринку (Stream A) та додатковий абонемент флоту (Plan Pro / Enterprise у форматі B2B) розраховуються наприкінці місяця з 14-денним терміном оплати. Власні замовлення складу (Stream B) розраховуються за ставкою 0 PLN (0%).",
    zeroHiddenFees: "0 PLN прихованих платежів",
    puescLoading: "Завантаження тарифів абонементів…",
    puescError: "Тарифи недоступні — зв'яжіться з нами.",
    puescKicker: "Абонементи Флоту та Інструменти Складу",
    puescPlansHeadline: "Оберіть пакет відповідно до розміру вашого автопарку",
    puescPlansLead: "Basic без фіксованих платежів (тільки комісія за нових клієнтів зі Stream A) або Pro / Enterprise з модулем PUESC (SENT та e-DD). Акційні ціни діють до кінця 2026 року.",
    puescNote: "Ціни абонементів нетто. Акційна пропозиція до кінця 2026 року. План Basic завжди 0 PLN/місяць та 0% комісії з власних прямих клієнтів (Stream B).",
    pdfTitle: "Завантажити буклет для постачальників (PDF)",
    pdfDesc: "Повний 2-сторінковий огляд: традиційний склад vs екосистема UgrzejMnie, QR-маніфест та розрахунок економії.",
    formHeadline: "Потрібна індивідуальна допомога з підключенням?",
    formLead: "Ви можете розпочати негайно, завантаживши мобільний додаток вище. Якщо у вас великий склад або автопарк — залиште контакти, ми зв'яжемося з вами.",
    formSubmit: "Надіслати запит на підключення",
  },
  b2bTech: {
    trustBar: "Безкоштовний тест — 1-ше виконане замовлення 100% безкоштовно · Цифровий протокол · Замовлення у вашому районі.",
    badge: "Зона B2B для монтажників та сервісантів HVAC",
    headline: "Більше замовлень у вашому районі та надійні розрахунки.",
    lead: "Отримуйте прямі запити від власників будинків на обслуговування теплових насосів (F-Гази), котлів, кондиціонерів та фотовольтаїки. 1-ше замовлення без комісії та без абонплати!",
    btnJoin: "Завантажити додаток і приєднатися",
    btnPricing: "Тарифи та тест",
    btnPdf: "Завантажити PDF",
    featuresHeadline: "Які замовлення чекають на вас в UgrzejMnie?",
    featuresLead: "Ми поєднуємо вас із замовниками точно у вибраному вами радіусі роботи.",
    pricingKicker: "Тарифи для сервісантів",
    pricingHeadline: "Безкоштовний тест та гнучкі районні абонементи",
    pricingLead: "Прозорі умови без прихованих платежів. Сплачуйте тільки тоді, коли хочете отримувати заявки з регіону.",
    trialTitle: "Вітальний пакет (Free First Job)",
    trialDesc: "Для кожного нового монтажника та сервісанта після реєстрації.",
    trialRate: "0 PLN",
    trialNote: "Перше виконане замовлення на 100% без комісії та абонплати",
    subsTitle: "Сервісний абонемент (30 днів)",
    subsDesc: "Активується після завершення безкоштовного пробного замовлення.",
    subsRate: "39 – 49 PLN / 30 днів",
    subsNote: "0% комісії від вартості послуг при активному абонементі",
    pdfTitle: "Завантажити буклет для сервісантів (PDF)",
    pdfDesc: "Дізнайтесь про всі деталі співпраці: розподіл заявок, цифрові акти та розрахунки прибутку.",
    formHeadline: "Потрібна допомога з реєстрацією компанії?",
    formLead: "Ви можете зареєструватися самостійно в мобільному додатку. Якщо у вас є питання — залиште контакти, ми допоможемо налаштувати профіль.",
    formSubmit: "Надіслати контактний запит",
  },
  faq: {
    heading: "Часті запитання",
    sub: "Коротко про те, як працює UgrzejMnie — перш ніж завантажити додаток.",
    q1: "Що таке UgrzejMnie?",
    a1: "Це додаток, який з'єднує вас з місцевими постачальниками палива та техніками опалення, кондиціонування і фотовольтаїки. Надішліть заявку, отримайте пропозиції і оберіть ту, що вам підходить.",
    q2: "Які послуги ви обслуговуєте?",
    a2: "У додатку можна замовити паливо і сервіс для котелень на твердому паливі (пелети, еко-горох), резервуарів LPG і пропану, газових котелень, теплових насосів та електроопалення, а також сервіс і монтаж кондиціонерів та установок фотовольтаїки.",
    q3: "Чи нагадає мені додаток про наближення сервісу?",
    a3: "Так. Ви можете зберегти свою опалювальну систему з датою наступного огляду. UgrzejMnie надішле вам сповіщення заздалегідь, щоб ви встигли замовити сервіс у потрібного техніка.",
    q4: "Хто доставляє паливо і виконує сервіс?",
    a4: "Незалежні постачальники і техніки з вашого регіону. UgrzejMnie — це маркетплейс: ми з'єднуємо сторони, але договір і виконання ви обговорюєте безпосередньо з обраним фахівцем.",
    q5: "Які способи оплати доступні на ugrzejmnie.pl?",
    a5: "Доступні способи залежать від пропозиції. Можна заплатити <strong>готівкою водієві (COD)</strong> за базовою ціною (0 PLN плати платформи) або обрати <strong>захищену онлайн-оплату</strong> (картка, BLIK, P24 чи Klarna) з Пакетом Безпечної Оплати — авторизація Stripe, безготівкове проведення та пріоритетна підтримка зі скаргами. Сервісний збір показується перед підтвердженням і залишається Оператору; постачальник отримує базову ціну пропозиції.",
    q6: "Як перевірити, які платежі приймає постачальник?",
    a6: "Прийнятні способи оплати завжди чітко відображаються на картці конкретної пропозиції при оформленні замовлення або запиті на кошторис.",
    q7: "Як працює відстрочена оплата Klarna за паливо?",
    a7: "Якщо обраний вами постачальник підтримує платежі Klarna, ви можете замовити паливо з опцією «Купіть зараз, заплатіть пізніше» (умови Klarna показані в Checkout). Ви отримуєте доставку відповідно до угоди з постачальником, а розрахунок з Klarna відбувається за її умовами.",
    q8: "Чи безпечні онлайн-платежі на ugrzejmnie.pl?",
    a8: "Так. Цифрові платежі обробляються через сертифікований платіжний шлюз Stripe, який відповідає найвищому міжнародному стандарту безпеки PCI-DSS Level 1. Жодні дані вашої картки не зберігаються на ugrzejmnie.pl.",
    q9: "Чи є додаток для iPhone?",
    a9: "Додатки для клієнтів і постачальників наразі доступні на Android. Версія для iOS розробляється і з'явиться незабаром.",
    q10: "Чи працює у моєму регіоні?",
    a10: "Пропозиції надходять від місцевих постачальників. Чим більше техніків у вашому регіоні, тим швидше ви отримаєте відповіді. Завантажте додаток і перевірте наявність у вашому районі.",
    q11: "Чому при доставці палива може знадобитися ідентифікаційний номер?",
    a11: "При доставці палива (рідкого, твердого, LPG, балонів) Платформа може вимагати ідентифікаційний номер для документації постачальника. Номер передається лише призначеному постачальнику і не використовується для маркетингу — деталі у Політиці конфіденційності.",
    q12: "Я технік — як почати?",
    a12: "Завантажте мобільний додаток постачальника, заповніть профіль і спеціалізації. Техніки починають без підписки: перше виконане сервісне замовлення (теплові насоси, котли, опалення, кондиціонери, PV) безкоштовне — з другого діє плата за категорію. Ви також можете запрошувати постійних клієнтів посиланням або QR-кодом. Для роботи за комп'ютером можна додати настільний додаток (Windows, macOS, Linux) — деталі у розділі Для постачальників.",
    q13: "Для чого настільний додаток постачальника?",
    a13: "Настільний комп'ютер — зручне доповнення за столом: сповіщення про нові замовлення і швидкі кошториси. Повне управління обліковим записом, спеціалізаціями і підпискою залишається в мобільному додатку — щоб конфіденційні налаштування були під контролем на телефоні.",
    q14: "Чому замовлення оформлюються у додатку, а не через веб-форму?",
    a14: "Мобільний додаток — це рівень безпеки для всього маркетплейсу. Він захищає постачальників і клієнтів від фальшивих замовлень, забезпечує миттєві push-сповіщення (про розцінки, терміни доставки та підтвердження операцій) і формує перевірену історію довіри — чого не дає звичайна форма на сайті.",
    q15: "Що таке спільна доставка палива?",
    a15: "Це спільна доставка з сусідами. Ви відкриваєте заявку в додатку, надсилаєте посилання або код, а сусіди долучаються зі своєю кількістю того самого палива й упаковки. Постачальник їде одним маршрутом — часто дешевше, ніж окремі поїздки.",
  },
  footer: {
    tagline: "Паливо і сервіс котельні — коли потрібно.",
    facebook: "Слідкуйте за нами у Facebook",
    toTop: "Нагору",
    contact: "Контакт",
    navigation: "Навігація",
    navAria: "Швидкі посилання",
    legal: "Інформація",
    legalAria: "Правова інформація",
    privacy: "Політика конфіденційності",
    terms: "Умови використання",
    apiDocs: "Портал Інтегратора (API)",
    pdfFuel: "Переваги для постачальників (PDF)",
    pdfLpgSent: "SENT станції LPG (інформатор)",
    forProviders: "Для Складів Палива",
    forTechnicians: "Для Сервісантів",
    copyright: "© 2026 UgrzejMnie · HelpMeNow Prosta S.A. Всі права захищені.",
    companyName: "HelpMeNow Prosta S.A.",
    address: "ul. Wspólna 2, 96-330 Mrozy, Польща",
    registry: "KRS 0001127133 · NIP 8381887256 · REGON 529645405",
    phone: "+48 690 355 556",
  },
  cookie: {
    text: "Наш сайт використовує файли cookie, необхідні для його правильної роботи, включно із запам'ятовуванням налаштувань. Більше інформації у нашій",
    privacyLink: "Політиці конфіденційності",
    accept: "Зрозуміло",
  },
};
